<template>
  <div class="client-main-body">
    <ClientHeader :cid="cid"/>
    <div class="client-home-tabs">
      <div class="container">
        <button class="client-home-tabs__item is-list " :class="{'is-active': isList}" type="button"
                @click="triggerItemMap('list')">Список
        </button>
        <button class="client-home-tabs__item is-map" :class="{'is-active': !isList}" type="button"
                @click="triggerItemMap('map')">Карта
        </button>
      </div>
    </div>
    <div class="switcher-wrap" :class="{'is-active': !isList}">
      <div class="container">
        <v-select
          class="metro_selector"
          placeholder="Укажите станцию метро"
          v-if="getUniqueMetroStations && !isMobileDevice"
          v-model="chosenSalon"
          :reduce="chosenSalon => chosenSalon.metro"
          label="metro"
          :options="getUniqueMetroStations"
          :searchable="false"
          @input="changeStation()">
          <template v-slot:option="salon">
            {{ salon.metro }}
            <metro-icon
              :station-color="salon.metro_hex_color">
            </metro-icon>
          </template>
        </v-select>
        <div v-else>
          <label for="metroStation">Укажите станцию метро</label>
          <select
            v-model="chosenSalon"
            id="metroStation"
            name="metroStation"
            v-if="getUniqueMetroStations"
            @input="changeStation()">
            <option selected disabled>Укажите станцию метро</option>
            <option v-for="salon in getUniqueMetroStations" :key="salon.id">
              {{ salon.metro }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <section class="client-wrapper">
      <div class="client-map" id="client-map" :class="{'is-active': !isList}">
        <div v-if="!YmapsInst" style="text-align: center; padding-top: 50px;">
          Простите карта на данный момент не доступна...
        </div>
      </div>
      <div class="client-slider" :class="{'is-hidden': !isList}">
        <!--        <div class="client-map" id="client-map" ></div>-->
        <!--        <div class="client-slider" >-->
        <loading :active.sync="isLoading"></loading>
        <loading :active="!salonsReady"></loading>
        <salons
          v-if="!isLoading && salonsReady && cid"
          :cid="cid"
          :mapPlacemarks="placemarks"
          :salons="allSalons"
          @onSetPath="setPath"
        />
      </div>
    </section>
    <div class="client-overlay">
      <div class="client-overlay__block">
        <p class="client-overlay__text">Вы действительно хотите завершить запись?</p>
        <a href="#" class="client-overlay__btn is-yes">Да</a>
        <a href="#" class="client-overlay__btn">Нет</a>
      </div>
    </div>
  </div>
</template>
<script>
import ClientHeader from '@/components/ClientHeader.vue';
import Salons from '@/components/Salons.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
import * as moment from 'moment';
import MetroIcon from '@/components/common/metroIcon';
import vSelect from 'vue-select'
import {isMobileDevice} from "../helpers/osChecker";

export default {
  name: 'client-home',
  data() {
    return {
      isLoading: true,
      currentDate: moment().format('YYYY-MM-DD'),
      chosenSalon: null,
      YmapsInst: null,
      placemarks: [],
      currentMarker: null,
      isList: true,
      isMap: false,
      geoError: 'Geolocation is not supported by this browser.',
      lat: null,
      lng: null,
      lastGeoObject: null,
      lastControlObject: null,
      currentPosition: [],
      allSalons: [],
      isAllowGeo: false,
      showBlockNotify: false,
      cid: '',
      el: null
    };
  },
  components: {
    ClientHeader,
    Salons,
    Loading,
    MetroIcon,
    vSelect
  },
  methods: {
    ...mapActions('salons', ['fetchSalons']),
    ...mapMutations('client', ['setCompanyId', 'readCompanySettings', 'setDate', 'currentSalonId']),
    changeStation() {
      let data = this.getUniqueMetroStations.find(geo => geo.metro === (this.chosenSalon));
      const _this = this;
      ymaps && ymaps.geocode(data && data.position, {
        results: 1
      }).then(res => {
        let firstGeoObject = res.geoObjects.get(0),
          metroCoords = firstGeoObject.geometry.getCoordinates();
        _this.YmapsInst.setCenter(metroCoords);
        _this.YmapsInst.setZoom(12);
      });
    },
    triggerItemMap(tab) {
      this.isList = tab === 'list';
    },
    showPosition(position) {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
      if (position) this.isAllowGeo = true;
      this.currentPosition = [position.coords.latitude, position.coords.longitude];
    },
    setDistance() {
      this.allSalons = [];
      this.salons.length && this.salons.forEach(salon => {
        if (!this.isAllowGeo || !this.YmapsInst) {
          salon.distance = 0;
          /* if location doesn't allow - set default salons array */
           this.allSalons.push(salon);
          return;
        }
        if (this.isAllowGeo && this.YmapsInst) {
          ymaps.route([this.currentPosition, ((salon && salon.position) || (`${salon.city}, ${salon.address}`))]).then(route => {
            let distance = route.getLength();
            salon.distance = Math.round(distance.toFixed(0) / 10) * 10;
            if (!this.allSalons.find(s => s.id === salon.id)) this.allSalons.push(salon);
          });
        }
      });
    },
    setPath(address) {
      let multiRouteModel = new ymaps.multiRouter.MultiRouteModel([
        [this.lat, this.lng],
        address
      ], {
        boundsAutoApply: true
      });

      // Создаём выпадающий список для выбора типа маршрута.
      let routeTypeSelector = new ymaps.control.ListBox({
        data: {
          content: 'Как добраться'
        },
        items: [
          new ymaps.control.ListBoxItem({data: {content: 'Авто'}, state: {selected: true}}),
          new ymaps.control.ListBoxItem({data: {content: 'Общественным транспортом'}}),
          new ymaps.control.ListBoxItem({data: {content: 'Пешком'}})
        ],
        options: {
          itemSelectOnClick: false
        }
      });

      // Получаем прямые ссылки на пункты списка.
      let autoRouteItem = routeTypeSelector.get(0);
      let masstransitRouteItem = routeTypeSelector.get(1);
      let pedestrianRouteItem = routeTypeSelector.get(2);

      // Подписываемся на события нажатия на пункты выпадающего списка.
      autoRouteItem.events.add('click', (e) => {
        changeRoutingMode('auto', e.get('target'));
      });
      masstransitRouteItem.events.add('click', (e) => {
        changeRoutingMode('masstransit', e.get('target'));
      });
      pedestrianRouteItem.events.add('click', (e) => {
        changeRoutingMode('pedestrian', e.get('target'));
      });

      this.YmapsInst && this.YmapsInst.controls.remove(this.lastControlObject);
      this.YmapsInst && this.YmapsInst.controls.add(routeTypeSelector);

      // Создаем на основе существующей модели мультимаршрут.
      let multiRoute = new ymaps.multiRouter.MultiRoute(multiRouteModel, {
        boundsAutoApply: true
      });

      // Добавляем мультимаршрут на карту.
      if (this.lastGeoObject) this.YmapsInst && this.YmapsInst.geoObjects.remove(this.lastGeoObject);
      this.YmapsInst && this.YmapsInst.geoObjects.add(multiRoute);

      function changeRoutingMode(routingMode, targetItem) {
        multiRouteModel.setParams({routingMode: routingMode}, true);

        // Отменяем выбор элементов.
        autoRouteItem.deselect();
        masstransitRouteItem.deselect();
        pedestrianRouteItem.deselect();

        // Выбираем элемент и закрываем список.
        targetItem.select();
        routeTypeSelector.collapse();
      }

      this.lastGeoObject = multiRoute;
      this.lastControlObject = routeTypeSelector;
      window.outerWidth <= 425 && this.triggerItemMap('map');
    },
    mapInit() {
      try {
        this.YmapsInst && this.YmapsInst.ready(() => {
          //create map
          this.YmapsInst = new ymaps.Map('client-map', {
            center: [55.76, 37.64],
            controls: ['zoomControl'],
            zoom: 10
          });

          // set distance into salons
          if (!this.isAllowGeo) this.setDistance();

          let salons = this.salons;
          let coords = [];
          let names = [];
          let ids = [];

          salons.map(s => {
            if (s) {
              coords.push(s.position);
              names.push(s.name);
              ids.push(s.id);
            }
          });

          let left = +Infinity, top = +Infinity, right = -Infinity, bottom = -Infinity;
          let myCollection = new ymaps.GeoObjectCollection();

          for (let i = 0; i < coords.length; i++) {
            if (coords[i] != null) {
              left = Math.min(left, coords[i][0]);
              right = Math.max(right, coords[i][0]);
              top = Math.min(top, coords[i][1]);
              bottom = Math.max(bottom, coords[i][1]);
            }
            this.placemarks = myCollection.add(
              new ymaps.Placemark(coords[i], {
                myId: ids[i],
                iconCaption: names[i]
              })
            );
          }
          if (Number.isFinite(left) && Number.isFinite(top) && Number.isFinite(bottom) && Number.isFinite(right)) {
            this.YmapsInst.setBounds([[left, top], [right, bottom]]);
            if (this.YmapsInst.getZoom() > 13) {
              // don't zoom too much on start.
              this.YmapsInst.setZoom(13);
            }
          }
          this.YmapsInst.geoObjects.add(myCollection);
          this.isLoading = false;


          if (this.placemarks) {
            for (let j = 0; j < this.placemarks && this.placemarks.getLength(); j++) {
              if (parseInt(this.placemarks.get(j).properties.get('myId')) === parseInt(this && this.$route && this.$route.query && this.$route.query.slide)) {
                let currentPm = this.placemarks.get(j);
                currentPm.options.set(
                  'preset', 'islands#redIcon'
                );
              }
            }

            //match marks and items on click
            if (this && this.placemarks && this.placemarks.events && (typeof this.placemarks.events.add === 'function')) {
              this.placemarks.events.add('click', (e) => {

                let markerId = e.get('target').properties.get('myId');

                // Цвет всех меток
                for (let j = 0; j < this.placemarks.getLength(); j++) {
                  let currentPm = this.placemarks.get(j);
                  currentPm.options.set(
                    'preset', 'twirl#blueStretchyIcon'
                  );
                }
                // Цвет текущей метки
                e.get('target').options.set('preset', 'islands#redIcon');

                if (this.$route.query.slide !== markerId) this.$router.push({query: {slide: markerId}}).catch(err => console.log(err));
              });
            }
          }

        })
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    }
  },
  computed: {
    ...mapState('salons', ['salons']),
    ...mapGetters('salons', ['getUniqueMetroStations']),
    salonsReady() {
      return this.salons.length === this.allSalons.length;
    },
    isMobileDevice() {
      return isMobileDevice()
    }
  },
  async beforeMount() {
    this.cid = this.$route.params.cid
    try {
      if (navigator.geolocation) navigator.geolocation.getCurrentPosition(this.showPosition);
      this.fetchSalons();
      this.readCompanySettings();
      this.setDate(this.currentDate);
    } catch (e) {
      console.log('ClientCompany.beforeMount: ', e)
    }
  },
  mounted() {
    this.el = this.$el
    let self = this;
    this.YmapsInst = (typeof ymaps !== 'undefined') ? ymaps : null;
    this.isLoading = !!this.YmapsInst;
    // Yandex MAP init
    if (this.$el && this.YmapsInst) this.mapInit();
    if(!this.YmapsInst) this.setDistance();
  },
  watch: {
    isAllowGeo(val) {
      if (val && this.currentPosition.length) {
        if (this.YmapsInst && this.YmapsInst.hasOwnProperty('ready')) {
          this.YmapsInst.ready(() => {
            this.setDistance();
          });
        } else {
          this.setDistance();
        }
      }
    }
  }
};

</script>
<style lang="sass">
@import "vue-select/src/scss/vue-select.scss"
// LAYOUT
$mobile-s: 375
$mobile: 568
$tablet: 767
$desktop: 992
$wide: 1336
$hd: 1440

// COLORS
$text-18: #181818
$text-36: #363636

// OPTIONS
$transitSpeed: .2s
$ease: ease-in-out

// SOCIALS
$twitter: #00aced
$facebook: #3b5998
$googleplus: #dd4b39
$pinterest: #cb2027
$linkedin: #007bb6
$youtube: #bb0000
$vimeo: #1ab7ea
$tumblr: #32506d
$instagram: #bc2a8d
$flickr: #ff0084
$dribbble: #ea4c89
$quora: #a82400
$foursquare: #0072b1
$forrst: #5B9A68
$vk: #45668e
$wordpress: #21759b
$stumbleupon: #EB4823
$yahoo: #7B0099
$blogger: #fb8f3d
$soundcloud: #ff3a00

// width
=r($width)
  @media only screen and (max-width: $width+ "px")
    @content

=rmin($width)
  @media only screen and (min-width: $width+ "px")
    @content

// height
=rh($height)
  @media only screen and (max-height: $height + "px")
    @content

=rhmin($height)
  @media only screen and (min-height: $height + "px")
    @content

.client-main-body
  .client-header
    &__address,
    &__cart
      display: none

    &__type i
      display: none

    &__pages
      display: none !important

.client-body
  height: 100vh
  overflow: hidden

.client-home-tabs
  display: none
  justify-content: flex-start
  align-items: center
  margin-bottom: 15px

  &__item
    background-color: transparent
    color: $text-36
    opacity: 0.7
    font-size: 14px
    font-weight: 400
    border: 0
    border-radius: 0
    margin-right: 20px

    &.is-active
      font-weight: 600
      opacity: 1

.switcher-wrap
  margin-bottom: 17px

  &__btn
    padding: 10px 32px
    font-size: 12px
    color: #000
    border: 0
    background-color: #fff
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1)
    transition: all $transitSpeed

    &:hover,
    &.is-active
      cursor: pointer
      background-color: $text-36
      color: #fff

    &:first-child
      border-top-left-radius: 6px
      border-bottom-left-radius: 6px

    &:last-child
      border-top-right-radius: 6px
      border-bottom-right-radius: 6px

  &__select
    font-size: 16px
    font-weight: 400
    border-radius: 0
    border: 0
    border-bottom: 1px solid $text-18
    color: $text-18
    padding: 9px 25px 9px 15px
    background-color: #fff
    -webkit-appearance: none
    -moz-appearance: none

    &:hover
      cursor: pointer

    &:disabled
      color: transparentize($text-18, 0.5)

.client-map
  width: 100%
  height: calc(100vh - 450px)
  max-height: 50vh
  margin-bottom: 25px

.client-slider
  transition: all $transitSpeed
  min-width: 251px

  &.is-hidden
    transform: translateX(-100%)

  &__wrap
    display: -webkit-flex
    display: -ms-flex
    position: relative
    display: flex
    justify-content: flex-start
    align-items: stretch
    flex-wrap: nowrap
    margin: 0 auto
    max-width: calc(100% - 60px)

    .slick-list
      padding: 10px 15px 10px 0 !important

  &__item
    box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1)
    border-radius: 10px
    transition: all $transitSpeed
    background-color: #fff
    color: #4d4d4d
    margin: 0 7px

    &:hover,
    &.map-current
      .client-slider__click-wrap
        background-color: $text-36
        color: #fff
  //min-width: 290px
  &__click-wrap
    text-align: center
    border: 1px solid gainsboro
    border-radius: 5px
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .3)
    padding: 15px
    height: 245px
    display: flex !important
    flex-direction: column
    transition: 0.3s all
    margin-bottom: 20px
    align-items: center

    &:hover
      color: white
      background: #4d4d4d

  &__title
    font-size: 14px
    line-height: 18px
    margin-top: 0
    margin-bottom: 5px
    font-weight: bold

  &__address
    font-weight: 500
    margin-top: 0
    margin-bottom: auto
    font-size: 12px

    img
      width: 25px !important
      display: inline !important
      vertical-align: middle

  &__time
    font-weight: 500
    margin-top: 5px
    margin-bottom: 0
    font-size: 12px

.client-overlay
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: transparentize($text-36, 0.6)
  display: none
  justify-content: center
  align-items: center
  z-index: 10

  &__block
    width: 100%
    max-width: 525px
    padding: 40px
    border-radius: 10px
    background-color: #fff
    text-align: center

  &__text
    font-size: 16px
    margin-top: 0
    margin-bottom: 30px
    text-align: center
    font-weight: 400
    max-width: 215px
    margin-left: auto
    margin-right: auto

  &__btn
    display: inline-block
    padding: 8px 40px
    text-align: center
    border: 1px solid $text-36
    border-radius: 8px
    color: $text-36
    font-size: 16px
    background-color: #fff
    margin: 0 7px

    &.is-yes,
    &:hover
      background-color: $text-36
      color: #fff

.client-priority
  .container
    height: calc(100vh - 70px)
    display: -webkit-flex
    display: -ms-flex
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center

  &__title
    font-size: 24px
    font-weight: 500
    color: $text-36
    margin-top: 0
    margin-bottom: 50px
    text-align: center

  &__link
    display: table
    color: $text-36
    font-weight: 400
    font-size: 24px
    padding-bottom: 3px
    border-bottom: 1px solid transparent
    margin-bottom: 35px
    transition: all $transitSpeed

    &:hover
      border-color: $text-36

    &:last-child
      margin-bottom: 0

+r($desktop)
  .client-slider
    &__item
      &:hover
        background-color: #fff
        color: $text-18

//max-width: $mobile
+r($mobile)
  .client-home-tabs
    display: flex
  .switcher-wrap
    margin-bottom: 0
    transition: all $transitSpeed
    transform: translateX(100%)
    // .container
    //   padding-left: 15px
    //   padding-right: 15px
    &.is-active
      transform: translateX(0%)

    .selectric
      border-bottom: 0

    .selectric-wrapper
      max-width: 100%
  .client-wrapper
    display: -webkit-flex
    display: -ms-flex
    display: flex
    align-items: flex-start
    justify-content: flex-start
    min-width: 251px
  //overflow-x: scroll
  .client-map
    width: 100%
    margin-bottom: 0
    height: calc(100vh - 150px)
    flex: 0 0 auto
    margin-top: 7px
    order: 0
    transition: all $transitSpeed

    &.is-active
      transform: translateX(-100%)
  .client-slider
    order: -1
    width: 100%
    flex: 0 0 auto
    margin-right: 0
    padding-top: 0
    margin-top: -40px

    &__wrap
      height: calc(100vh - 100px)
      overflow-y: auto
      justify-content: flex-start
      align-items: flex-start
      flex-direction: column
      max-width: 100%
      margin: 0
      padding: 7px 30px
      display: block !important
      -webkit-overflow-scrolling: touch

    &__item
      padding: 0
      width: 100%
      margin: 0 0 20px 0

    &__click-wrap
      min-height: 170px
  .client-overlay
    &__block
      max-width: calc(100% - 30px)
      padding: 20px

    &__text
      font-size: 14px
      margin-bottom: 20px

    &__btn
      font-size: 14px
      padding: 10px 20px
      margin: 0 5px
  .client-priority
    &__title
      font-size: 16px
      margin-bottom: 20px

    &__link
      min-width: 115px
      text-align: center
      font-size: 16px
      padding: 10px 25px
      margin-bottom: 20px
      border-radius: 8px
      background-color: #fff
      color: $text-36
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1)

      &:hover
        background-color: $text-36
        color: #fff

.client-one-parametrs__block-wrap
  overflow-y: auto
  height: calc(100% - 160px)

.metro_selector
  max-width: 300px
  .vs__dropdown-menu
    z-index: 1000
</style>
